import React, { useEffect, useState } from "react";
import { Alert, Button, Spin } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import OrderPage from "./laptop/orderPage";
import OrderPageMobile from "./mobiles/orderPageMobile";
import { useMediaQuery } from "react-responsive";
import { trackBookingStarted } from "../services/analyticsEvents";
import { getBranchs } from "../features/branchSlide";
import { onResetRoom, onSetFormSearch } from "../features/checkRoomSlide";

const OrderWrapper = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1224px)" });
  const [params] = useSearchParams();
  const requestedBranch = params.get("branch") || "";
  const [entry, setEntry] = useState({ branch: "", error: "", attempt: 0 });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0, { behavior: "smooth" }); }, []);
  useEffect(() => { trackBookingStarted({ device_type: isDesktop ? "desktop" : "mobile" }); }, [isDesktop]);
  useEffect(() => {
    if (!requestedBranch) return undefined;
    let active = true;
    dispatch(getBranchs()).unwrap().then((branches) => {
      if (!active) return;
      if (!Array.isArray(branches) || !branches.some((branch) => String(branch._id) === requestedBranch)) {
        setEntry((previous) => ({ ...previous, branch: requestedBranch, error: "Cơ sở này hiện chưa nhận đặt phòng. Vui lòng chọn cơ sở khác." }));
        return;
      }
      // Enter step one with this branch only; never reuse an old booking or price.
      dispatch(onResetRoom());
      dispatch(onSetFormSearch({ branch: requestedBranch }));
      setEntry((previous) => ({ ...previous, branch: requestedBranch, error: "" }));
    }).catch(() => {
      if (active) setEntry((previous) => ({ ...previous, branch: requestedBranch, error: "Chưa tải được thông tin cơ sở. Vui lòng thử lại." }));
    });
    return () => { active = false; };
  }, [dispatch, requestedBranch, entry.attempt]);

  if (requestedBranch && entry.branch !== requestedBranch) return <Spin tip="Đang chọn cơ sở"><div style={{ minHeight: 160 }} /></Spin>;
  if (requestedBranch && entry.error) return <Alert type="error" message={entry.error} action={<>
    <Button onClick={() => setEntry((previous) => ({ branch: "", error: "", attempt: previous.attempt + 1 }))}>Thử lại</Button>
    <Button onClick={() => { dispatch(onResetRoom()); dispatch(onSetFormSearch({})); navigate("/order", { replace: true }); }}>Chọn cơ sở khác</Button>
  </>} />;
  return isDesktop ? <OrderPage key={requestedBranch} /> : <OrderPageMobile key={requestedBranch} />;
};
export default OrderWrapper;
